export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string[];
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageSeq: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'hong-kong-category-iii-origin',
    title: '香港三级片分级制度的起源与演变',
    excerpt: '1988年11月10日，香港《电影检查条例》正式生效，标志着香港电影三级分级制度的诞生。本文追溯三级制度的立法背景、社会动因与制度设计的深层逻辑。',
    content: [
      '香港电影分级制度的诞生，是多重社会力量博弈的结果。20世纪80年代，香港电影产业蓬勃发展，类型片百花齐放，但同时也出现了大量涉及暴力、色情内容的影片。社会舆论对电影内容管控的呼声日益高涨，政府面临着平衡创作自由与社会责任的挑战。',
      '1987年，港英政府开始着手研究电影分级制度的可行性。经过一年多的调研与草案修订，《电影检查条例》（第392章）于1988年11月10日正式生效。该条例将电影分为三个级别：第I级（适合任何年龄人士观看）、第II级（儿童不宜）和第III级（只准年满18岁人士观看）。',
      '三级制的核心设计理念在于"分类而非审查"——政府不对电影内容进行预先审查，而是通过年龄分级来保护未成年人，同时保障成年观众的观影选择权。这一制度设计体现了自由主义与保护主义的精妙平衡。',
      '1995年，第II级进一步细分为IIA级（儿童不宜）和IIB级（青少年及儿童不宜），使分级体系更加精细。这一调整反映了社会对青少年保护的持续关注，也为电影创作者提供了更明确的创作边界。',
      '三级制的建立对香港电影生态产生了深远影响。一方面，它为成人题材电影提供了合法的市场空间；另一方面，三级标签也意外地成为某些影片的营销卖点，"三级片"一词逐渐演变为一个具有特定文化含义的类型标签。',
    ],
    category: 'grading-system',
    author: '陈文华',
    date: '2026-07-15',
    readTime: '12分钟',
    imageSeq: 'article-01',
    tags: ['香港电影', '分级制度', '电影检查条例', '立法背景'],
  },
  {
    slug: 'category-iii-global-comparison',
    title: '全球视野下的三级片：各国电影分级制度比较',
    excerpt: '将香港三级制度置于国际比较框架中，分析其与美国MPAA、英国BBFC、日本映伦等分级体系的异同，揭示不同文化背景下电影审查的共性与差异。',
    content: [
      '电影分级制度在全球范围内呈现多元化的面貌。美国采用行业自律的MPAA分级体系，英国设有法定的BBFC分级委员会，日本则由行业组织映画伦理委员会（映伦）进行分级。每个国家的分级制度都深刻烙印着其文化传统、法律体系和社会价值观。',
      '与美国的G/PG/PG-13/R/NC-17五级制相比，香港的三级制显得简洁明了。美国R级（17岁以下需家长陪同）类似于香港的IIB级，而NC-17级（17岁以下禁止观看）则与香港的第III级功能相近。但美国的NC-17级在实际操作中面临院线排片的阻力，而香港的第III级则是电影市场中被广泛接受的正常分级。',
      '英国的BBFC分级体系经历了从严格审查到宽松分级的转变。从1912年成立至今，BBFC的分级标准不断随社会变迁而调整。与香港三级制相似，英国的18级同样禁止未成年人观看，但BBFC在暴力内容的判定上往往比性内容更为严格。',
      '日本的电影分级制度以映伦为核心，分为G/PG12/R15+/R18+四个级别。日本R18+级别与香港第III级功能相似，但日本在动画、漫画等媒介的分级管理上更为细致，形成了涵盖多种媒介的完整分级生态。',
      '韩国的映像物等级委员会采用全体/12+/15+/青少年不可观看四级制，与香港三级制在结构上颇为相似。两国都面临着如何在保护青少年与保障表达自由之间取得平衡的共同课题。',
    ],
    category: 'asian-classification',
    author: '林志明',
    date: '2026-07-10',
    readTime: '15分钟',
    imageSeq: 'article-02',
    tags: ['国际比较', 'MPAA', 'BBFC', '日本映伦', '电影审查'],
  },
  {
    slug: 'fruit-of-eden-analysis',
    title: '《爱の果実》：三级片史上的里程碑之作',
    excerpt: '1993年上映的《爱の果実》被视为香港三级片艺术化的开山之作。本文从叙事结构、视觉美学和社会意义三个维度，解读这部作品的独特价值。',
    content: [
      '1993年注定是香港三级片历史上不平凡的一年。《爱の果実》的上映，打破了三級片等同于低俗色情片的刻板印象，以精良的制作、深刻的主题和出色的表演，证明了三级片同样可以是一种严肃的艺术表达。',
      '影片在叙事结构上采用了非线性叙事手法，通过男女主角在不同时空中的情感纠葛，探讨了欲望、道德与社会规范之间的复杂关系。导演以细腻的镜头语言，将情欲场景升华为情感表达的有机组成部分，而非单纯的感官刺激。',
      '在视觉美学层面，影片大量运用了柔光摄影、象征性构图和隐喻性色彩搭配。红色的反复出现象征着欲望与禁忌，蓝色的冷调则暗示着孤独与疏离。这种高度风格化的视觉语言，使影片超越了普通三级片的制作水准。',
      '从社会意义来看，《爱の果実》深刻反映了1990年代香港社会面临的价值观转型。影片中对传统道德观念的质疑、对个体自由的追求，与香港社会当时的文化氛围高度契合，使其成为时代精神的影像注脚。',
      '《爱の果実》的成功，为香港三级片开辟了一条艺术化的道路。此后涌现出的一批高质量三级片作品，共同推动了这一类型的文化升级，使其在亚洲电影史中占据了不可忽视的位置。',
    ],
    category: 'representative-works',
    author: '张雅婷',
    date: '2026-06-28',
    readTime: '10分钟',
    imageSeq: 'article-03',
    tags: ['代表作品', '电影分析', '视觉美学', '社会意义'],
  },
  {
    slug: 'taiwan-film-rating',
    title: '台湾电影分级制度与三级片的文化接受',
    excerpt: '台湾的电影分级制度与香港既有联系又有区别。本文分析台湾分级制度的历史沿革，以及台湾社会对三级片的文化接受态度变化。',
    content: [
      '台湾的电影分级制度经历了从戒严时期的严格管制到民主化后的逐步开放。1980年代以前，台湾电影受《电影法》和新闻局的严格管控，任何涉及敏感内容的影片都可能遭到禁映或删剪。',
      '随着1987年解严后的社会开放，台湾于1988年确立了电影分级制度，分为普通级、保护级、辅导级和限制级四个级别。其中限制级（未满18岁不得观看）与香港的第III级功能相似，但台湾的分级标准在某些方面更为保守。',
      '香港三级片在台湾的传播，是一个有趣的文化接受现象。尽管许多香港三级片在台湾被列为限制级，但它们通过录像带、影碟等渠道广泛流传，在台湾形成了独特的"三级片亚文化"。',
      '台湾本土的三级片制作虽然规模远不及香港，但也有少数作品在艺术性上进行了探索。这些作品往往融合了台湾新电影的写实美学与三级片的类型元素，形成了独特的风格。',
      '近年来，随着OTT平台的兴起和全球化的观影趋势，台湾观众对三级片的接受态度也发生了变化。年轻一代更倾向于将三级片视为电影艺术的一个分支，而非带有道德判断的标签。',
    ],
    category: 'asian-classification',
    author: '王晓明',
    date: '2026-06-20',
    readTime: '11分钟',
    imageSeq: 'article-04',
    tags: ['台湾电影', '分级制度', '文化接受', '限制级'],
  },
  {
    slug: 'censorship-law-analysis',
    title: '香港电影审查制度的法律框架与实施机制',
    excerpt: '以《电影检查条例》为核心，系统分析香港电影审查的法律依据、执行机构、审查流程和申诉机制，揭示制度运行的完整图景。',
    content: [
      '《电影检查条例》（第392章）是香港电影审查制度的基石。该条例明确了电影检查的目的——"在保障表达自由的同时，适当保护观众免受不良影响，并特别关注对青少年的保护"。这一立法目的体现了香港法律体系中权利平衡的核心理念。',
      '电影检查由影视及娱乐事务管理处（电影检查小组）负责执行。检查员通常由行政长官委任，需要具备相关专业背景。检查制度采取"上映前送检"模式，所有计划在香港公开放映的电影都必须提前送检。',
      '审查标准主要关注以下几个方面：是否宣扬暴力、是否包含淫亵或不雅内容、是否可能损害香港与其他地区的关系、是否可能煽动犯罪。值得注意的是，条例明确排除了对"艺术价值"和"教育价值"的审查——这为三级片的艺术化提供了制度空间。',
      '影片被评定为第III级后，影院必须严格执行年龄验证程序。违规放映三级片给未成年人的影院可能面临罚款甚至吊销执照的处罚。这一执行机制的严格性，确保了分级制度的实际效力。',
      '申诉机制是制度完善性的重要体现。电影发行商或制作方对分级决定不满时，可以向电影检查复核委员会提出复核申请。复核委员会由社会各界人士组成，确保了审查决定的多元视角和公正性。',
    ],
    category: 'censorship',
    author: '李建国',
    date: '2026-06-15',
    readTime: '13分钟',
    imageSeq: 'article-05',
    tags: ['审查制度', '法律框架', '电影检查条例', '执行机制'],
  },
  {
    slug: 'golden-era-category-iii',
    title: '1990年代：香港三级片的黄金时代',
    excerpt: '1990年代是香港三级片创作最为活跃的时期。本文回顾这个"黄金时代"的产业背景、创作特征和文化影响，还原一个时代的电影记忆。',
    content: [
      '如果说1988年三级制的建立为三级片提供了制度框架，那么1990年代则是三级片大放异彩的时代。这一时期，香港三级片年产量一度超过百部，占据了香港电影总产量的相当比例。',
      '产业层面的繁荣有多重原因。首先，香港电影整体处于黄金时期，年产影片超过两百部，市场容量巨大。其次，录像带市场的蓬勃发展开辟了新的发行渠道，降低了三级片的投资风险。第三，东南亚和台湾市场的需求旺盛，为三级片提供了广阔的出口空间。',
      '在创作层面，1990年代的三级片呈现出多元化的面貌。既有以情欲为主要卖点的商业类型片，也有追求艺术表达的严肃作品；既有本土题材的深度挖掘，也有跨国合作的国际视野。这种多元化使得三级片成为一个容纳各种创作可能性的类型容器。',
      '明星效应是这一时期三级片繁荣的重要因素。不少知名演员参与三级片演出，提升了这一类型的制作水准和公众关注度。同时，三级片也成为许多新人导演和演员进入电影行业的跳板。',
      '1990年代末期，随着香港电影产业的整体下滑、盗版问题的加剧以及观众口味的转变，三级片的黄金时代逐渐落幕。但这一时期留下的作品遗产和产业经验，至今仍是研究香港电影史不可忽视的重要组成部分。',
    ],
    category: 'history',
    author: '陈文华',
    date: '2026-06-08',
    readTime: '14分钟',
    imageSeq: 'article-06',
    tags: ['黄金时代', '1990年代', '产业分析', '创作特征'],
  },
  {
    slug: 'sociology-of-category-iii',
    title: '禁忌与欲望：三级片的社会学解读',
    excerpt: '从社会学理论出发，探讨三级片作为"禁忌消费"的社会功能，分析其如何折射社会价值观变迁、性别政治和阶层文化。',
    content: [
      '三级片作为一种特殊的文化商品，其社会功能远超出单纯的娱乐范畴。从社会学视角来看，三级片是一个观察社会规范、权力关系和价值观变迁的绝佳透镜。',
      '禁忌消费理论认为，社会通过设立禁忌来维持秩序，但同时也为禁忌的"合法僭越"提供了空间——三级片正是这种合法僭越的典型形式。成年观众在安全的观影环境中体验禁忌，既满足了好奇心，又不会真正挑战社会规范。',
      '性别视角是分析三级片不可回避的维度。早期三级片普遍存在男性凝视的叙事特征，女性身体被客体化为欲望的对象。但随着社会性别意识的提升，越来越多的作品开始反思和颠覆这一传统，呈现出更加多元的性别表达。',
      '在阶层分析层面，三级片的观众群体跨越了社会各阶层。对于劳工阶层来说，三级片是一种廉价而直接的娱乐方式；对于中产阶层来说，三级片可能是一种带有"文化僭越"意味的消费行为。这种跨阶层的消费特征，使三级片成为研究大众文化的独特样本。',
      '当代社会学研究越来越关注三级片在全球化语境中的变迁。流媒体平台的兴起改变了三级片的消费方式，使其从公共空间（影院）转移到私人空间（家庭），这一变化对三级片的社会功能产生了深远影响。',
    ],
    category: 'cultural-studies',
    author: '赵思远',
    date: '2026-05-30',
    readTime: '16分钟',
    imageSeq: 'article-07',
    tags: ['社会学', '禁忌消费', '性别研究', '大众文化'],
  },
  {
    slug: 'japan-pink-film-history',
    title: '日本粉红电影与香港三级片的跨文化对话',
    excerpt: '日本粉红电影（Pink Film）与香港三级片在发展轨迹上有诸多相似之处。本文对比两种类型的产业模式和美学特征，展现东亚成人电影的丰富图景。',
    content: [
      '日本粉红电影的历史可以追溯到1960年代。与香港三级片相似，粉红电影也是在电影产业寻求新增长点的背景下诞生的。1962年，小林悟导演的《肉体市场》被视为日本第一部粉红电影，开启了这一类型长达数十年的发展历程。',
      '日本粉红电影形成了独特的产业模式。大型制片厂（如日活）和独立制作公司（如大藏映画）共同推动了粉红电影的发展。特别是日活的"浪漫色情"系列，在1970年代以低成本、高效率的制作模式，挽救了陷入财务危机的公司，这一现象与香港三级片在1990年代对电影产业的贡献颇有相似之处。',
      '在美学层面，日本粉红电影呈现出与香港三级片不同的特征。日本粉红电影更加注重氛围营造和心理描写，常常融入物哀美学传统；而香港三级片则更注重叙事节奏和戏剧冲突。两者的差异反映了中日两国不同的审美传统和电影文化。',
      '日本粉红电影培养了一批后来成为国际知名导演的电影人，如黑泽清、周防正行、泷田洋二郎等。他们通过在粉红电影中磨练技艺，最终走向了更广阔的电影舞台。香港三级片同样为许多电影人提供了创作起点。',
      '在全球化时代，日本粉红电影和香港三级片都面临着产业转型的挑战。数字化、流媒体和全球化竞争正在重塑成人电影的市场格局。两种类型如何在新环境中保持文化特色和艺术追求，是一个值得持续关注的话题。',
    ],
    category: 'asian-classification',
    author: '林志明',
    date: '2026-05-22',
    readTime: '13分钟',
    imageSeq: 'article-08',
    tags: ['日本电影', '粉红电影', '跨文化比较', '产业模式'],
  },
  {
    slug: 'digital-era-category-iii',
    title: '数字时代的香港三级片：转型与挑战',
    excerpt: '互联网和流媒体彻底改变了三级片的制作、发行和消费方式。本文探讨数字时代三级片面临的机遇与挑战，以及其未来的可能走向。',
    content: [
      '进入21世纪，数字技术对三级片产业产生了颠覆性影响。传统的院线发行模式逐渐衰落，取而代之的是DVD/蓝光直销、视频点播和流媒体订阅等多元化发行渠道。这种渠道变革既带来了新的机遇，也带来了前所未有的挑战。',
      '数字化制作降低了三级片的制作门槛。高清数字摄影机和后期制作软件的普及，使小团队甚至个人也能完成三级片的制作。这虽然降低了行业的准入门槛，但也导致了内容质量的参差不齐和市场供给的过度膨胀。',
      '互联网的兴起使香港三级片面临来自全球的竞争。日本、韩国、欧美等地的成人内容通过互联网轻易触达香港观众，打破了曾经由地域和渠道形成的市场壁垒。香港三级片需要在内容特色和文化价值上寻找差异化竞争力。',
      '监管环境在数字时代面临新的难题。传统三级制的核心机制——影院年龄验证——在流媒体环境中几乎无法执行。如何在互联网环境中有效保护未成年人，同时不过度限制成年人的合法观影权利，是政策制定者面临的两难课题。',
      '展望未来，香港三级片可能需要重新定义自身的文化定位。在成人内容供给极度丰富的数字环境中，"三级片"的标签意义正在消解。或许未来的三级片将更多地回归其艺术本质——作为一种严肃的成人题材电影，而非简单的类型标签。',
    ],
    category: 'history',
    author: '张雅婷',
    date: '2026-05-15',
    readTime: '12分钟',
    imageSeq: 'article-09',
    tags: ['数字时代', '流媒体', '产业转型', '未来展望'],
  },
  {
    slug: 'south-korea-film-rating',
    title: '韩国电影分级制度与成人电影的崛起',
    excerpt: '韩国电影分级制度经历了从严格审查到分级管理的转变。本文分析韩国成人电影产业的发展历程，以及与香港三级制度的异同。',
    content: [
      '韩国电影分级制度的发展史，是一部从威权审查走向民主分级的演变史。在军政府时期（1960-1980年代），电影内容受到严格的意识形态审查，涉及性、暴力和政治敏感的内容一律禁止。这种审查制度严重制约了韩国电影的艺术发展。',
      '1996年，韩国宪法法院裁定电影事前审查制度违宪，这一历史性判决开启了韩国电影分级制度的新时代。1999年，映像物等级委员会（KMRB）成立，采用全体/12+/15+/18+的四级分类体系，标志着韩国电影管理从事前审查转向事后分级。',
      '分级制度的建立为韩国成人电影（18+级别）提供了合法空间。与香港三级片不同，韩国的成人电影更加侧重于艺术性和社会批判性。导演金基德的许多作品虽然被列为18+级别，但其艺术价值获得了国际影坛的高度认可。',
      '韩国18+级别电影与香港第III级电影在制度设计上最大的差异在于分级标准的透明度。韩国的分级标准更加明确具体，而香港的分级标准保留了较大的裁量空间。这两种模式的差异反映了不同的法律传统和文化偏好。',
      '近年来，韩国18+级别电影在国际电影节上屡获殊荣，证明了成人题材电影同样可以达到艺术巅峰。这一现象对香港三级片的未来发展具有重要启示：唯有回归艺术本质，三级片才能真正赢得文化尊重。',
    ],
    category: 'asian-classification',
    author: '王晓明',
    date: '2026-05-08',
    readTime: '14分钟',
    imageSeq: 'article-10',
    tags: ['韩国电影', '分级制度', '成人电影', '金基德'],
  },
  {
    slug: 'mainland-china-film-censorship',
    title: '中国大陆电影审查制度与分级讨论',
    excerpt: '中国大陆至今未建立电影分级制度，仍采用审查制。本文分析大陆电影管理的现状，探讨分级制讨论的各方观点，以及香港三级制度的参照意义。',
    content: [
      '中国大陆的电影管理制度以《电影产业促进法》为主要法律依据，采用电影审查制而非分级制。所有计划在中国大陆公映的电影，都必须通过国家电影局的审查，获得《电影公映许可证》（俗称"龙标"）。',
      '审查制的核心特征在于事前审查和内容把关。审查标准涵盖政治、道德、文化等多个维度，不仅禁止未成年人不宜的内容，也对所有年龄段的观众设定了统一的内容标准。这种"一刀切"的模式在保护未成年人的同时，也限制了成人题材电影的创作空间。',
      '近年来，关于在中国大陆建立电影分级制度的讨论日趋热烈。支持者认为，分级制可以更好地平衡保护未成年人和保障创作自由两方面的需求，并为中国电影的类型多元化提供制度支持。反对者则担心分级制可能带来内容管理的弱化。',
      '香港三级制度的经验对大陆具有重要的参照意义。香港三级制的成功运作表明，分级制度并不会导致道德滑坡，反而可以通过明确的规则引导市场健康发展。同时，香港三级制度中"分类而非审查"的理念，为大陆的改革讨论提供了有价值的思路。',
      '展望未来，中国大陆电影分级制度的建立仍面临诸多挑战，包括法律框架的修改、执行机制的建立和社会共识的形成。但无论改革的具体路径如何，香港三级制度的实践经验都将是重要的参考资源。',
    ],
    category: 'censorship',
    author: '李建国',
    date: '2026-04-28',
    readTime: '13分钟',
    imageSeq: 'article-11',
    tags: ['中国大陆', '电影审查', '分级讨论', '制度改革'],
  },
  {
    slug: 'aesthetics-of-category-iii',
    title: '三级片的视觉美学：欲望的诗意表达',
    excerpt: '超越道德评判，从视觉美学的角度审视三级片中欲望的诗意表达方式。分析光线、色彩、构图等电影语言如何建构三级片独特的美学世界。',
    content: [
      '三级片常常被简化为"色情"的代名词，但这种标签化的理解遮蔽了其丰富的视觉美学维度。事实上，优秀的三级片作品在视觉语言上往往具有高度的艺术自觉，运用电影本体语言来诗意地表达欲望。',
      '光线是三级片视觉美学中最具表现力的元素。柔和的侧光可以塑造人物的立体感和肌肤质感；昏暗的环境光营造出暧昧氛围；高对比度的光影则暗示道德与欲望的冲突。灯光设计在三级片中不仅是技术手段，更是情感表达的载体。',
      '色彩在三级片中的运用同样富有深意。红色调象征着激情与危险的双重含义；蓝色调传递着孤独与忧郁；暖黄色则营造出怀旧和温柔的质感。色彩的饱和度、对比度和冷暖对比，构成了三级片独特的视觉语法。',
      '空间构图是理解三级片视觉美学的另一把钥匙。封闭空间象征着压抑与渴望；镜面反射暗示着自我认知的困境；门窗框架则成为欲望边界的视觉隐喻。这些空间元素的运用，使三级片的视觉语言超越了单纯的叙事功能。',
      '当代三级片的视觉美学正在发生新的变化。数字摄影技术的进步带来了更高的画质和更灵活的拍摄方式；视觉特效的运用为想象力的表达提供了新的可能。但无论如何变化，视觉美学始终是三级片作为一种电影类型最基础的艺术价值所在。',
    ],
    category: 'cultural-studies',
    author: '赵思远',
    date: '2026-04-20',
    readTime: '11分钟',
    imageSeq: 'article-12',
    tags: ['视觉美学', '电影语言', '光线设计', '色彩运用'],
  },
];

export const articleMap: Record<string, Article> = {};
articles.forEach((article) => {
  articleMap[article.slug] = article;
});

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getRelatedArticles(currentSlug: string, limit: number = 3): Article[] {
  const current = articleMap[currentSlug];
  if (!current) return articles.slice(0, limit);
  return articles
    .filter((a) => a.slug !== currentSlug && a.category === current.category)
    .slice(0, limit);
}